/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useEffect } from "react";
import Family from "../assets/Family_Registration.png";
import { fetchApi } from "../utlis/axios";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { IoMdClose } from "react-icons/io";

export const PropertyRegistration = ({setShowModal, familyId}) => {
  const [step, setStep] = useState(1);
  const navigate = useNavigate();
  const [type, setType] = useState("date");
  const { id } = useSelector((state) => state.authSlice.userInfo?.user);
  const { access } = useSelector((state) => state.authSlice.userInfo);
  const [documentError, setDocumentError] = useState("");
  const [familyData, setFamilyData] = useState();
  const [family, setFamily] = useState();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    name: "",
    type: "",
    worth: null,
    owned_since: "",
    description: "",
    pin_location: "",
    family: null,
    documents: [],
  });


  const [validationErrors, setValidationErrors] = useState({
    family: "",
    documents: [],
  });

  const handleNext = () => {
    setStep(step + 1);
  };

  const handleFileInputChange = async (e) => {
    const newFiles = e.target.files;

    if (newFiles.length > 0) {
      setLoading(true);
      const updatedSelectedFiles = [...selectedFiles];

      for (let i = 0; i < newFiles.length; i++) {
        const file = newFiles[i];
        const data = new FormData();
        data.append("file", file);
        data.append("type", "Property Document");
        data.append("is_active", true);

        try {
          const result = await fetchApi.post("attachments/", data, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${access}`,
            },
          });

          if (result?.status === 201) {
            updatedSelectedFiles.push({ id: result.data.id, name: file.name });
          }
        } catch (error) {
          console.error("Error uploading file:", error);
          setDocumentError(
            "Error uploading one or more files. Please try again."
          );
          setLoading(false);
          return; // Stop further processing on error
        }
      }

      setSelectedFiles(updatedSelectedFiles);
      setLoading(false);
      setDocumentError(""); // Clear any previous error
    } else {
      setDocumentError("Please select at least one file.");
    }
  };

  const handleFileDelete = (index) => {
    const updatedSelectedFiles = [...selectedFiles];
    updatedSelectedFiles.splice(index, 1);
    setSelectedFiles(updatedSelectedFiles);
  };

  const PropertyRegistration = async (e) => {
    e.preventDefault();
    // if (!validateForm()) {
    //     return;
    // }
    try {
      setLoading(true);
      const data = new FormData();
      data.append("id", id);
      data.append("name", formValues?.name);
      data.append("type", formValues?.type);
      data.append("worth", formValues?.worth);
      data.append("owned_since", formValues?.owned_since);
      data.append("description", formValues?.description);
      data.append("pin_location", formValues?.pin_location);
      data.append("family", formValues?.family || familyId);
      data.append("is_active", true);

      const result = await fetchApi.post("property/", data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${access}`,
        },
      });
      if (result?.status === 201) {
        console.log("Family data", data);
        navigate(`/familylistingdetail/${familyId || formValues?.family}`);
      }
      setFormValues({
        ...formValues,
        name: "",
        type: "",
        worth: "",
        owned_since: "",
        description: "",
        pin_location: "",
        family: null,
        documents: [],
      });
    } catch (error) {
      console.log({ error });
    } finally {
      setLoading(false); // Set loading back to false when API call is completed
    }
  };

  const getFamilydata = async () => {
    try {
      const result = await fetchApi.get(`family/${familyId}`, {
        headers: {
          Authorization: `Bearer ${access}`, // Replace with your API key
        },
      });
      if (result.status === 200) {
        setFamilyData(result.data);
        console.log("Family data...", result.data);
      } else {
        console.error("Failed to fetch data:", result.status);
      }
    } catch (error) {
      console.log({ error });
    }
  };

  const getFamily = async () => {
    try {
      const result = await fetchApi.get("family/", {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });
      if (result?.status === 200) {
        setFamily(result?.data);
        console.log("Families data...", result.data);
      } else {
        console.error("Failed to fetch data:", result.status);
      }
    } catch (error) {
      console.log({ error });
    }
  };

  const validateForm = () => {
    let valid = true;
    const errors = {
      family: "",
      documents: [],
    };

    if (!familyId) {
      // If familyId is not present, check if formValues.family is empty
      if (!formValues.family) {
        valid = false;
        errors.family = "Family is required";
      }
    }

    if (!selectedFiles.length) {
      valid = false;
      errors.documents = "Property Doc is required";
    }
    setValidationErrors(errors);
    return valid;
  };

  useEffect(() => {
    getFamilydata();
    getFamily();
  }, []);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div className="fixed inset-0 z-[100] flex justify-center ">
    {/* backdrop */}
    <div
      className="absolute inset-0 bg-black/50"
      onClick={() => setShowModal(false)}
    ></div>

    {/* modal wrapper */}
    <div className="flex items-center justify-center overflow-y-auto w-full min-h-screen py-8 md:py-16 px-[16px] sm:px-4">
      <div className="relative z-[200] w-full max-w-4xl my-auto">
        <div className="bg-[#FFFFFF] rounded-3xl shadow-xl">
          {/* Close button */}
          <button
            className="absolute w-max top-4 right-4 text-gray-700 bg-primary-green/10 p-1 rounded-full cursor-pointer text-black              hover:text-gray-700 text-2xl"
            onClick={() => setShowModal(false)}
          >
            <IoMdClose />
          </button>

          {/* Header */}
          <div className="px-6 pt-6 pb-4 border-b">
            <h2 className="text-2xl font-semibold text-gray-800">
              Property Registration
            </h2>
          </div>
            <div className="field_Container">
              {step === 1 && (
                <>
                  <form
                    onSubmit={PropertyRegistration}
                    className="form_responsive"
                  >
                    <div className="group-fields">
                      <div className="field-container">
                        <h6 className="field-txt">Property name</h6>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          placeholder="Property name"
                          className="formField"
                          value={formValues?.name}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              name: e.target.value,
                            })
                          }
                          required
                        />
                      </div>

                      <div className="field-container">
                        <h6 className="field-txt">Property Type</h6>
                        <select
                          type="text"
                          id="type "
                          name="type "
                          className="formField custom-select"
                          value={formValues?.type}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              type: e.target.value,
                            })
                          }
                          required
                          style={{ paddingRight: "70px" }}
                        >
                          <option>Select</option>
                          <option value="Farming Land ">Farming Land </option>
                          <option value="5 to 10 lacs">5 to 10 lacs</option>
                          <option value="Residencial Property(House,Flat, or Plot)">
                            Residencial Property(House,Flat, or Plot)
                          </option>
                          <option value="Comercial Property(Shop,Comerical Land or plot)">
                            Comercial Property(Shop,Comerical Land or plot)
                          </option>
                          <option value="House Holds(Animals, Vehicles)">
                            House Holds(Animals, Vehicles)
                          </option>
                          <option value="Others">Others</option>
                        </select>
                      </div>
                    </div>

                    <div className="group-fields">
                      <div className="field-container">
                        <h6 className="field-txt">Property worth</h6>
                        <select
                          type="text"
                          id="worth "
                          name="worth "
                          className="formField custom-select"
                          value={formValues?.worth}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              worth: e.target.value,
                            })
                          }
                          required
                        >
                          <option>Select</option>
                          <option value="5 lacs or less">5 lacs or less</option>
                          <option value="5 to 10 lacs">5 to 10 lacs</option>
                          <option value="10 to 20 lacs">10 to 20 lacs</option>
                          <option value="20 to 50 lacs">20 to 50 lacs</option>
                          <option value="50 lacs or more">
                            50 lacs or more
                          </option>
                        </select>
                      </div>

                      <div className="field-container">
                        <h6 className="field-txt">Property owned since</h6>
                        <input
                          type={type}
                          id="ownd"
                          name="ownd"
                          placeholder="Property owned since"
                          onFocus={(event) => {
                            event.target.type = "date";
                          }}
                          className="formField"
                          onClick={(e) => setType("date")}
                          value={formValues?.owned_since}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              owned_since: e.target.value,
                            })
                          }
                          required
                        />
                      </div>
                    </div>

                    <div className="group-fields">
                      <div className="field-container">
                        <h6 className="field-txt">Description</h6>
                        <input
                          type="text"
                          id="Description"
                          name="Description"
                          placeholder="Description"
                          className="formField"
                          value={formValues?.description}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              description: e.target.value,
                            })
                          }
                          required
                        />
                      </div>
                      <div className="field-container">
                        <h6 className="field-txt">Location</h6>
                        <input
                          type="text"
                          id="location"
                          name="location"
                          placeholder="Property location"
                          value={formValues?.pin_location}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              pin_location: e.target.value,
                            })
                          }
                          className="formField"
                          required
                        />
                      </div>
                    </div>
                    {!familyId && (
                      <div className="group-fields">
                        <div className="field-container">
                          <h6 className="field-txt">Select Family</h6>

                          <select
                            type="text"
                            id="Family "
                            name="Family "
                            placeholder="Select Family"
                            className="formField custom-select"
                            value={formValues?.family}
                            onChange={(e) =>
                              setFormValues({
                                ...formValues,
                                family: e.target.value,
                              })
                            }
                            required
                          >
                            <option>Select</option>
                            {family?.results?.map((item) => {
                              return (
                                <option value={item?.id}>{item?.name}</option>
                              );
                            })}
                          </select>

                          <span className="error-message text-danger">
                            {validationErrors.family}
                          </span>
                        </div>
                      </div>
                    )}

                    <div className="pb-2">
                      <button className="popup-button primary-button" disabled={loading}>
                        {loading ? "Loading..." : "Register"}
                      </button>
                    </div>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
